module.exports = __webpack_public_path__ + "static/media/midautumnbg.1cbe60e1.jpg";